var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_37797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4V28H28",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33203 11.9997C9.33203 12.7069 9.61298 13.3852 10.1131 13.8853C10.6132 14.3854 11.2915 14.6663 11.9987 14.6663C12.7059 14.6663 13.3842 14.3854 13.8843 13.8853C14.3844 13.3852 14.6654 12.7069 14.6654 11.9997C14.6654 11.2924 14.3844 10.6142 13.8843 10.1141C13.3842 9.61396 12.7059 9.33301 11.9987 9.33301C11.2915 9.33301 10.6132 9.61396 10.1131 10.1141C9.61298 10.6142 9.33203 11.2924 9.33203 11.9997Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.668 9.33366C22.668 10.0409 22.9489 10.7192 23.449 11.2193C23.9491 11.7194 24.6274 12.0003 25.3346 12.0003C26.0419 12.0003 26.7202 11.7194 27.2203 11.2193C27.7204 10.7192 28.0013 10.0409 28.0013 9.33366C28.0013 8.62641 27.7204 7.94814 27.2203 7.44804C26.7202 6.94794 26.0419 6.66699 25.3346 6.66699C24.6274 6.66699 23.9491 6.94794 23.449 7.44804C22.9489 7.94814 22.668 8.62641 22.668 9.33366Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19.9997C16 20.7069 16.281 21.3852 16.781 21.8853C17.2811 22.3854 17.9594 22.6663 18.6667 22.6663C19.3739 22.6663 20.0522 22.3854 20.5523 21.8853C21.0524 21.3852 21.3333 20.7069 21.3333 19.9997C21.3333 19.2924 21.0524 18.6142 20.5523 18.1141C20.0522 17.614 19.3739 17.333 18.6667 17.333C17.9594 17.333 17.2811 17.614 16.781 18.1141C16.281 18.6142 16 19.2924 16 19.9997Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5469 14.1602L16.6669 18.0002",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1172 17.7709L23.8999 11.6562",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_37797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/Progress.f70d9c26892b8c95b52f10f73f9e131a.svg";
export { ForwardRef as ReactComponent };